export const CAPTCHA_PROVIDER_CONFIG = 'Commons.CaptchaProvider';
export const CAPTCHA_PROVIDER = {
  turnstile: 'Turnstile',
  recaptcha: 'ReCaptcha',
};
